import api from "../core/http";

/**
 * Get News object for news feed
 * - uses react-query
 * @param {*} type
 * @returns
 */
export const getNews = () => {
  return api
    .get("/v1/news")
    .then((res) => res.data)
    .catch((err) => err);
};
